import type { SelfCollisionSlice, SelfCollisionState, ViewerSliceCreator } from "./types";

export const selfCollisionInitialState: SelfCollisionState = {
  selfCollisionEnabled: true,
  selfCollisionAvailable: true,
  collidingMeshUuids: [],
  collidingLinkPairs: [],
};

export const createSelfCollisionSlice: ViewerSliceCreator<SelfCollisionSlice> = (set) => ({
  ...selfCollisionInitialState,

  setSelfCollisionEnabled: (enabled) =>
    set((state) => {
      state.selfCollisionEnabled = enabled;
    }),

  setSelfCollisionState: (msg) =>
    set((state) => {
      state.selfCollisionEnabled = msg.enabled;
      state.selfCollisionAvailable = msg.available;
      state.collidingMeshUuids = msg.mesh_uuids;
      state.collidingLinkPairs = msg.link_pairs;
    }),
});
